import { render, staticRenderFns } from "./editnotice.vue?vue&type=template&id=59eca844&"
import script from "./editnotice.vue?vue&type=script&lang=ts&"
export * from "./editnotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editnotice.vue"
export default component.exports